import {makeAutoObservable} from 'mobx';
import LearnerRepository from '../../../../data/repositories/LearnerRepository';
import {toast} from 'react-toastify';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';
import CoursesRepository from '../../../../data/repositories/CoursesRepository';

class CourseLearnerStore {
  private learnerRepository = new LearnerRepository();
  private coursesRepo = new CoursesRepository();
  private callback?: () => void;

  constructor() {
    makeAutoObservable(this);
  }

  public async saveLearners(
    selectedLearners: string[],
    organizationId: string,
    courseId: string,
    dueDate?: Date,
  ) {
    const result = await this.learnerRepository.addLearnersToCourse(
      selectedLearners,
      organizationId,
      courseId,
      dueDate,
    );
    if (result.success) {
      toast.success('Learner(s) added successfully', toastConfig);

      if (this.callback) {
        this.callback();
      }
      return result.success;
    } else {
      toast.error('There was an issue adding learner(s)', toastConfig);
      return result.success;
    }
  }

  public async getCourse(organizationId: string, courseId: string) {
    const course = await this.coursesRepo.getCourse(organizationId, courseId);
    return course.data;
  }

  public async getOrganizationLearners(
    organizationId: string,
    courseId: string,
    page: number,
    pageSize: number,
    search?: string,
  ) {
    const result = await this.learnerRepository.getEnrollmentCandidates(
      organizationId,
      courseId,
      page,
      pageSize,
      search,
    );

    if (result.success && result.data) {
      return result.data;
    }

    return {
      data: [],
      pagesCount: 0,
    };
  }

  public async getEnrolledLearnersCount(
    organizationId: string,
    courseId: string,
  ) {
    const result = await this.learnerRepository.getMyLearners(
      0,
      organizationId,
      1,
      [courseId],
      '',
    );

    if (result.success && result.data) {
      return result.data.pagesCount;
    }

    return 0;
  }
}

export default CourseLearnerStore;
